import Vue from "vue";
import _ from "lodash";
import moment from "moment";

const URL = "/db/training";
const API_URL = URL + "/api/";

const state = {
  training: [],
  pel_tipe: [],
  pel_tempat: [],
  training_loaded: false,
  training_init: true
};

const getters = {
  trainingInjected(state) {
    return state.training;
  },
  trainingByLaman(state, getters, rootState) {
    return state.training.filter(o => o.id_laman == rootState.id_laman$);
  },
  trainingByLamanPeriode(state, getters, rootState) {
    return state.training.filter(tr => {
      let bool = tr.id_laman == rootState.id_laman$;
      if (bool && moment(rootState.periode$).isValid()) {
        bool = moment(tr.waktu_mulai).format("YYYY") == rootState.periode$;
      }
      return bool;
    });
  },
  trainingSayaByLaman(state, getters, rootState) {
    return state.training.filter(tr => {
      let bool = tr.id_user == rootState.auth.profil.id_user;
      if (bool) bool = tr.id_laman == rootState.id_laman$;
      return bool;
    });
  },
  trainingSayaByLamanPeriode(state, getters, rootState) {
    return state.training.filter(tr => {
      let bool = tr.id_user == rootState.auth.profil.id_user;
      if (bool) bool = tr.id_laman == rootState.id_laman$;
      if (bool && moment(rootState.periode$).isValid()) {
        bool = moment(tr.waktu_mulai).format("YYYY") == rootState.periode$;
      }
      return bool;
    });
  }
};

const mutations = {
  INIT(state) {
    if (state.training_init) state.training_init = false;
  },
  LOADED(state, payload) {
    state.training_loaded = payload;
  },
  SET_PEL_TIPE(state, payload) {
    state.pel_tipe = payload;
  },
  SET_PEL_TEMPAT(state, payload) {
    state.pel_tempat = payload;
  },
  SET_TRAINING(state, payload) {
    state.training = payload;
  },
  ADD_TRAINING(state, payload) {
    state.training.push(payload);
  },
  UPDATE_TRAINING(state, payload) {
    state.training = _.unionBy([payload], state.training, "id_training");
  },
  DELETE_TRAINING(state, ids) {
    _.remove(state.training, function(training) {
      return ids.includes(training.id_training);
    });
    state.training = [...state.training];
  }
};

const actions = {
  GET_OPTIONS({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(URL + "/options").then(res => {
      commit("SET_PEL_TIPE", res.data.pel_tipe);
      commit("SET_PEL_TEMPAT", res.data.pel_tempat);
      commit("laman/SET_LAMAN", res.data.laman, { root: true });
      commit("materi/SET_MATERI", res.data.materi, { root: true });
      commit("client/SET_CLIENT", res.data.client, { root: true });
      commit("trainer/SET_TRAINER", res.data.trainer, { root: true });
      commit("LOADING_DONE", null, { root: true });
    });
  },
  GET_TRAINING({ commit }) {
    commit("LOADING", null, { root: true });
    commit("LOADED", false);
    return Vue.axios.get(API_URL).then(res => {
      commit("INIT");
      commit("LOADED", true);
      commit("SET_TRAINING", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  },
  ADD_TRAINING({ commit, rootState }, payload) {
    // prepare the data
    let options = {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: function(progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        commit("UPLOAD_PROGRESS", percentCompleted, { root: true });
      }
    };
    let formData = new FormData();
    for (let i = 0; i < payload.photos.length; i++) {
      formData.append(
        `photos[${payload.photos[i].pel_photo_tipe}][]`,
        payload.photos[i].pel_photo
      );
    }
    for (let i = 0; i < payload.files.length; i++) {
      formData.append(
        `files[${payload.files[i].pel_file_tipe}]`,
        payload.files[i].pel_file
      );
    }
    formData.append("json_data", JSON.stringify(payload));
    // to server
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(URL + "/api_custom/", formData, options)
      .then(res => {
        commit("ADD_TRAINING", res.data);
        commit("SUCCESS", "Berhasil menambah...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, { root: true });
        throw e;
      });
  },
  UPDATE_TRAINING({ commit, rootState }, payload) {
    // prepare the data
    let options = {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: progressEvent => {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        commit("UPLOAD_PROGRESS", percentCompleted, { root: true });
      }
    };
    let formData = new FormData();
    for (let i = 0; i < payload.photos.length; i++) {
      formData.append(
        `photos[${payload.photos[i].pel_photo_tipe}][]`,
        payload.photos[i].pel_photo
      );
    }
    for (let i = 0; i < payload.files.length; i++) {
      formData.append(
        `files[${payload.files[i].pel_file_tipe}]`,
        payload.files[i].pel_file
      );
    }
    formData.append("json_data", JSON.stringify(payload));
    // to server
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(URL + "/api_custom/" + payload.id_training, formData, options)
      .then(res => {
        commit("UPDATE_TRAINING", res.data);
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  DELETE_TRAINING({ commit }, payload) {
    let ids = payload.map(p => p.id_training).join(",");
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .delete(API_URL + ids)
      .then(res => {
        commit("DELETE_TRAINING", res.data.ids);
        if (typeof res.data.errors !== "undefined")
          commit("ERROR", res.data.errors, { root: true });
        else commit("SUCCESS", "Berhasil menghapus...", { root: true });
        return res.data.ids;
      })
      .catch(() => {
        commit("ERROR", "Data masih dipakai di tabel lain!", {
          root: true
        });
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
